<template>
    <div class="mortgage-program-accordeon__content">
        <div class="mortgage-program-accordeon _dflex _justify-content-between" :class="{'mortgage-program-accordeon_active': visible}" @click="changeVisibility">
            <h3 class="h3"> {{ detailText }} </h3>
            <button class="mortgage-program-accordeon__button" :class="{'mortgage-program-accordeon__button_inverted': visible}">
                <DIcon :name="EIcon.ARROW_DOWN" :size="EIconSize.S_16" :color="EIconColor.WHITE_101" class="_flex-none" />
            </button>
        </div>
        <slot name="header"></slot>
        <div :class="{'_dblock': visible}" v-show="visible"><slot name="main"></slot></div>
    </div>
</template>

<script>
    import { DIcon, EIcon, ESize as EIconSize, EColor as EIconColor } from '@ahml/domrfbank-ui/elements/DIcon';

    export default {
        name: "MortgageAccordeon",
        props: {
            detailText: {
                type: String,
                default: 'Подробнее об условиях'
            },
            visibility: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DIcon
        },
        data() {
            return {
                visible: false,
                triggeredBy: '',
                EIcon,
                EIconSize,
                EIconColor
            }
        },
        methods: {
            changeVisibility() {
                this.visible = !this.visible;
                this.triggeredBy = 'user';
            }
        },
        updated() {
            if (this.triggeredBy === 'user') {
                this.triggeredBy = 'auto';
            }
            else if (this.triggeredBy !== 'user' && !this.$props.visibility)  {
                this.visible = false;
            }
        },
        mounted() {
            this.visible = this.$props.visibility ? true : false;
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .mortgage-program-accordeon {
        @include fluid('margin-top', 32px, 28px);
        @include fluid('padding-bottom', 24px);
        border-bottom: 1px solid $grey-134;
        cursor: pointer;
        transition: all ease-in-out .3s;

        &__content {
            transition: all ease-in-out .3s;
        }

        &__button {
            display: flex;
            justify-content: center;
            align-items: center;
            @include fluid('width', 32px);
            @include fluid('min-width', 32px);
            @include fluid('height', 32px);
            border-radius: 50%;
            background-color: $grey-1514;
            cursor: pointer;

            &_inverted {
                transform: rotate(180deg);
            }

            &:hover {
                background-color: $hover-graphite;
            }
        }

        &_active {
            border-bottom: initial;
            padding-bottom: 0px;
        }
    }
</style>
